import { render, staticRenderFns } from "./view-all-address.vue?vue&type=template&id=0bceaeb3&scoped=true"
import script from "./view-all-address.vue?vue&type=script&lang=js"
export * from "./view-all-address.vue?vue&type=script&lang=js"
import style0 from "./view-all-address.vue?vue&type=style&index=0&id=0bceaeb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bceaeb3",
  null
  
)

export default component.exports